import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import CircularProgress from "@material-ui/core/CircularProgress";

import Input from "../../common/Input";

import * as Constants from "../../../helpers/Constants";
import * as ConfigActions from "../../actions/Config";
import * as CommunityActions from "../../actions/Communities";
import * as Strings from "./strings";

const INITIAL_STATE = {
  name: "",
  emailAddress: "",
  password: "",
  errorPassword: "",
  janitor: "",
  phoneNumber: "",
  address: "",
  postalNumber: "",
  firstName: "",
  lastName: "",
  city: "",
  orgNumber: "",
  price: "",
  errorMessage: "",
  laundryBookingSystem: false,
  errorReportSystem: false,
  feedSystem: false,
  infoSystem: false,
  bookingSystem: false,
  apartments: null
};

class CreateCorporationModal extends Component {
  state = { ...INITIAL_STATE };

  componentDidUpdate(prevProps) {
    const { communities } = this.props;

    if (prevProps.communities.isCreating && !communities.isCreating) {
      if (!communities.errorCreating) {
        this.props.hideCreateCorporationModal();
        this.resetFields();
        this.props.showSnackbar(Strings.default.CORPORATION_CREATED);
      } else {
        this.setState({ errorMessage: Strings.default.INTERNAL_ERROR });
      }
    }
  }

  createCorparation() {
    const { user } = this.props;
    const {
      name,
      emailAddress,
      phoneNumber,
      address,
      postalNumber,
      firstName,
      lastName,
      city,
      orgNumber,
      price,
      janitor,
      laundryBookingSystem,
      errorReportSystem,
      feedSystem,
      infoSystem,
      bookingSystem,
      apartments,
      password,
      errorPassword
    } = this.state;

    this.setState({ errorMessage: "" });

    if (name === "") {
      this.setState({ errorName: Strings.default.MANDATORY_FIELD });
    }

    if (emailAddress === "") {
      this.setState({ errorEmailAddress: Strings.default.MANDATORY_FIELD });
    }

    if (janitor === "") {
      this.setState({ errorJanitor: Strings.default.MANDATORY_FIELD });
    }

    if (password === "") {
      this.setState({ errorPassword: Strings.default.MANDATORY_FIELD });
    }

    if (
      name !== "" &&
      emailAddress !== "" &&
      janitor !== "" &&
      password !== ""
    ) {
      const data = {
        ...this.state,
        laundryBookingSystem,
        errorReportSystem,
        feedSystem,
        infoSystem,
        bookingSystem,
        password
      };
      this.props.tryCreateCommunity(user.token, data);
    }
  }

  resetFields() {
    this.setState({ ...INITIAL_STATE });
  }

  render() {
    const {
      name,
      errorName,
      emailAddress,
      errorEmailAddress,
      janitor,
      errorJanitor,
      phoneNumber,
      address,
      postalNumber,
      firstName,
      lastName,
      city,
      orgNumber,
      price,
      errorMessage,
      laundryBookingSystem,
      errorReportSystem,
      feedSystem,
      infoSystem,
      bookingSystem,
      password,
      errorPassword
    } = this.state;
    const { config, classes, communities, user } = this.props;

    return (
      <Dialog
        open={config.createCorparationModal.show}
        aria-labelledby={"form-dialog-title"}
      >
        <div style={{ width: "80vw" }}></div>
        <DialogTitle id={"form-dialog-title"}>
          {Strings.default.NEW_CORPORATION}
        </DialogTitle>
        <DialogContent>
          {errorMessage === "" ? null : (
            <p style={{ fontSize: 12, color: "#e57373" }}>{errorMessage}</p>
          )}
          <Input
            onChange={text => this.setState({ name: text, errorName: "" })}
            value={name}
            placeholder={Strings.default.CORPORATION_NAME + "*"}
            error={errorName}
          />
          <Input
            onChange={text => this.setState({ orgNumber: text })}
            value={orgNumber}
            placeholder={Strings.default.ORG_NUMBER}
          />
          <Input
            onChange={text =>
              this.setState({
                emailAddress: text,
                errorEmailAddress: ""
              })
            }
            value={emailAddress}
            placeholder={Strings.default.BILLING_AND_PHONE_EMAIL + "*"}
            error={errorEmailAddress}
          />
          <Input
            onChange={text =>
              this.setState({
                password: text,
                errorPassword: ""
              })
            }
            value={password}
            placeholder={Strings.default.PASSWORD + "*"}
            error={errorPassword}
          />
          <Input
            onChange={text =>
              this.setState({
                janitor: text,
                errorJanitor: ""
              })
            }
            value={janitor}
            placeholder={Strings.default.JANITOR + "*"}
            error={errorJanitor}
          />
          <Input
            onChange={text => this.setState({ phoneNumber: text })}
            value={phoneNumber}
            placeholder={Strings.default.CONTACT_NUMBER}
          />
          <Input
            onChange={text => this.setState({ firstName: text })}
            value={firstName}
            placeholder={Strings.default.CONTACT_FIRST_NAME}
          />
          <Input
            onChange={text => this.setState({ lastName: text })}
            value={lastName}
            placeholder={Strings.default.CONTACT_LAST_NAME}
          />
          <Input
            onChange={text => this.setState({ address: text })}
            value={address}
            placeholder={Strings.default.ADDRESS}
          />
          <Input
            onChange={text => this.setState({ postalNumber: text })}
            value={postalNumber}
            placeholder={Strings.default.ZIP_CODE}
          />
          <Input
            onChange={text => this.setState({ city: text })}
            value={city}
            placeholder={Strings.default.CITY}
          />
          <Input
            onChange={text => this.setState({ price: text })}
            value={price}
            placeholder={Strings.default.PRICE}
          />
          <DialogContentText>Tjänster</DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={laundryBookingSystem}
                onChange={() =>
                  this.setState({ laundryBookingSystem: !laundryBookingSystem })
                }
              />
            }
            label="Tvättbokning"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={errorReportSystem}
                onChange={() =>
                  this.setState({ errorReportSystem: !errorReportSystem })
                }
              />
            }
            label="Felanmälan"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={feedSystem}
                onChange={() => this.setState({ feedSystem: !feedSystem })}
              />
            }
            label="Flöde"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={infoSystem}
                onChange={() => this.setState({ infoSystem: !infoSystem })}
              />
            }
            label="Information"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={bookingSystem}
                onChange={() =>
                  this.setState({ bookingSystem: !bookingSystem })
                }
              />
            }
            label="Övrig bokning"
          />
          <DialogContentText>Lägenhetsregister (.xlsx)</DialogContentText>
          <input
            accept=".xlsx"
            type="file"
            style={{ marginTop: 24 }}
            onChange={event =>
              this.setState({ apartments: event.target.files[0] })
            }
          />
        </DialogContent>
        {communities.isCreating ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: "#289e64" }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => {
                this.props.hideCreateCorporationModal();
                this.resetFields();
              }}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => this.createCorparation()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

const Styles = {
  successButtonText: {
    color: "#289e64"
  },
  warningButtonText: {
    color: "#e57373"
  }
};

function mapStateToProps({ user, config, communities }) {
  return { user, config, communities };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...ConfigActions, ...CommunityActions },
    dispatch
  );
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CreateCorporationModal);



// WEBPACK FOOTER //
// ./src/components/containers/CreateCorporationModal/index.js